import { render } from "./SearchSteam.vue?vue&type=template&id=2827fd82"
import script from "./SearchSteam.vue?vue&type=script&lang=js"
export * from "./SearchSteam.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__